import { Typography, Stack, Box, CircularProgress } from '@mui/joy'
import Post from '../Post/Post';
import { usePosts } from '../../../hooks/post/usePosts';
import ServerError, { NotFound } from '../ServerError/ServerError';
import ShowMoreButton from './ShowMoreButton';

// Поиск показывает только самые релевантные совпадения — без бесконечной ленты
const MAX_RESULTS = 5;

function ListShow({ results = [], hasMore, loadingMore, loadMore }) {
    return (
        <>
            <Stack spacing={2}>
                {results.map((post, index) => (
                    <Post post={post} key={post?.id ?? index} />
                ))}
            </Stack>
            {hasMore && (
                <ShowMoreButton count={MAX_RESULTS} loading={loadingMore} onClick={loadMore} />
            )}
        </>
    )
}

function PostResults({ query }) {
    const search = (query ?? '').trim();
    const hasQuery = search.length > 0;

    const { posts, loading, error, hasMore, loadingMore, loadMore } = usePosts({ q: search, limit: MAX_RESULTS, enabled: hasQuery });

    const results = Array.isArray(posts) ? posts : [];

    if (!hasQuery) {
        return (
            <NotFound
                img="no-messages.svg"
                title="Начните вводить запрос"
                desc="Введите слово или фразу, чтобы найти записи пользователей"
            />
        )
    }

    return (
        <>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <CircularProgress />
                </Box>
            ) : error ? (
                <ServerError />
            ) : posts ? (
                <>
                    {results.length > 0 ? (
                        <ListShow
                            results={results}
                            hasMore={hasMore}
                            loadingMore={loadingMore}
                            loadMore={loadMore}
                        />
                    ) : (
                        <NotFound />
                    )}
                </>
            ) : null}
        </>
    )
}

export default PostResults
